import React, { useState, useEffect } from "react";
import {
  Routes,
  Route,
  useNavigate,
  useLocation
} from "react-router-dom";
import Reset from "./pages/login/reset";
import Register from "./pages/login/register";
import Login from "./pages/login";
import ListLogin from "./pages/login/listLogin";
import Docs from "./pages/app/docs";
import Requirements from "./pages/requirements";
import UploadCpdregoperac from "./pages/app/uploadCpdregoperac";
import ListRequirements from "./pages/app/requirements/list";
import Requirement from "./pages/app/requirements/index";
import Order from "./pages/app/orders/index";
import Orders from "./pages/app/orders/list";
import Prices from "./pages/app/fixPrices";
import './App.css';
import docsService from "./services/docs";
import AuthService from "./services/security/auth.service";
import constants from "./utils/constants";
import Position from "./pages/app/position";
import HomeAdmin from "./pages/app/homeAdmin";
//import { ThemeProvider } from '@mui/material/styles';
//import constantsDesign from './utils/constants';
//import MenuApp from './components/Menu';

function App() {

  const [docs, setDocs] = useState([]);
  const [instance, setInstance] = useState([]);
  let navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {

    const user = AuthService.getCurrentUser();
    if (user) {
      setInstance(user.data.instance);
      docsService.viewDocsFindAll(constants.CLIENT, user.data.instance).then((response) => {
        setDocs(response.data);
      }).catch((error) => {
        navigate('/')
        console.log(error);
      });
    } else {
      //navigate('/')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /*if (!instance || docs.length === 0) {

    if (location.pathname !== '/') {
      return <ThemeProvider theme={constantsDesign.CUSTOM_MUI_GENERAL_THEME}>
        <div style={{ overflowX: 'hidden' }}>
          <MenuApp />
        </div>
      </ThemeProvider>
    }
  }*/

  return (
    <Routes location={location} key={location.pathname}>
      <Route path="/" element={<Login />} />
      <Route path="/listlogin" element={<ListLogin />} />
      <Route path="/position" element={<Position />} />
      <Route path="/adminHome" element={<HomeAdmin />} />
      <Route path={'/requirements'} element={<Requirements />} />
      <Route path="/uploadCpdregoperac" element={<UploadCpdregoperac />} />
      <Route path="/reset" element={<Reset />} />
      <Route path="/register" element={<Register />} />
      <Route path="/listrequirements" element={<ListRequirements instance={instance} />} />
      <Route path="/requirement" element={<Requirement instance={instance} />} />

      <Route path="/newOrderFix" element={<Order instance={instance} />} />
      <Route path="/ordersFix" element={<Orders instance={instance} />} />

      <Route path="/pricesFix" element={<Prices />} />

      {docs.map((item, index) => {
        let path = null;
        if (item.crud) {
          path = `${item.crud.route}`
        }
        return item.crud ? <Route key={index} path={path} element={<Docs data={item} instance={instance} pathParameter={path} />} /> : null

      })}

      {docs.map((item, index) => {
        let path = null;
        if (item.crud) {
          path = `${item.crud.route}`
        }
        return item.crud ? <Route key={index} path={`${path}?id=:id`} element={<Docs data={item} instance={instance} pathParameter={path} />} /> : null
      })}
    </Routes>
  );
}

export default App;
